import RemoveBeneficiaryError from './RemoveBeneficiaryError';
class RemoveBeneficiaryNotFound extends RemoveBeneficiaryError {
    constructor(options) {
        super('The beneficiary was not found', options);
    }
}
export default RemoveBeneficiaryNotFound;
